(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('PhoneCallResultGroupSearch', PhoneCallResultGroupSearch);

    PhoneCallResultGroupSearch.$inject = ['$resource'];

    function PhoneCallResultGroupSearch($resource) {
        var resourceUrl =  'api/_search/phone-call-result-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
